import { api } from "@/lib/api";

// ---------------- Credits ----------------

export const getMyCredits = () =>
  api.get(`/student/credits`).then((r) => r.data);

export const adminListCredits = (params) =>
  api.get(`/admin/credits`, { params }).then((r) => r.data);

export const adminGrantCredit = (body) =>
  api.post(`/admin/credits/grant`, body).then((r) => r.data);

export const adminRevokeCredit = (creditId) =>
  api.post(`/admin/credits/${creditId}/revoke`).then((r) => r.data);

// ---------------- Referrals ----------------

export const listMyReferrals = () =>
  api.get(`/student/referrals`).then((r) => r.data);

export const createReferral = (courseId) =>
  api.post(`/student/referrals`, { course_id: courseId }).then((r) => r.data);

export const disableReferral = (referralId) =>
  api.post(`/student/referrals/${referralId}/disable`).then((r) => r.data);

// Public — invite banner decoder. Returns { valid, referral_id, referrer_name,
// course_id, course_title, referrer_bonus_inr/usd, referred_bonus_inr/usd, reason }.
export const decodeReferralToken = (token) =>
  api.get(`/referrals/decode`, { params: { token } }).then((r) => r.data);

// ---------------- Referral defaults (admin) ----------------

export const adminGetReferralDefaults = () =>
  api.get(`/admin/payment-settings/referral-defaults`).then((r) => r.data);

export const adminPutReferralDefaults = (patch) =>
  api.put(`/admin/payment-settings/referral-defaults`, patch).then((r) => r.data);

// ---------------- Local storage helpers (pending referral token) ----------------

const PENDING_KEY = "kks_pending_referral_token";

export function savePendingReferralToken(courseId, token) {
  try {
    localStorage.setItem(
      PENDING_KEY,
      JSON.stringify({ courseId, token, savedAt: Date.now() })
    );
  } catch {
    /* localStorage disabled — fall through silently */
  }
}

export function readPendingReferralToken(courseId) {
  try {
    const raw = localStorage.getItem(PENDING_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.courseId !== courseId) return null;
    // 30d expiry mirrors backend
    if (Date.now() - (parsed.savedAt || 0) > 30 * 24 * 60 * 60 * 1000) {
      clearPendingReferralToken();
      return null;
    }
    return parsed.token;
  } catch {
    return null;
  }
}

export function clearPendingReferralToken() {
  try {
    localStorage.removeItem(PENDING_KEY);
  } catch {
    /* noop */
  }
}
